import { useEffect, useState } from 'react'
import Dashboardnavbar from '../../layout/Dashboardnavbar';
import SubCompany from './SubCompany/SubCompany';
import Division from './Devision/Division';
import axios from 'axios';
import { BASE_URL } from '../../config/axios';
import { AddSubcompany } from './SubCompany/AddSubCompany';
import { AddDivision } from './Devision/AddDivision';

const MainDivision = () => {

    const [toggleState, setToggleState] = useState(1);

    const [subComapany, setSubCompany] = useState([]);
    const [buffer, setBuffering] = useState(false);
    const [buffer2, setBuffering2] = useState(false);

    const getSubcompany = async () => {
        setBuffering(true);

        try {
            const result = await axios.get(`${BASE_URL}/dpr/subcompany/`);
            setSubCompany(result.data);
        } catch (err) {
            console.error("Error fetching sub-companies:", err);
        } finally {
            setBuffering(false);
        }
    };




    useEffect(() => {
        getSubcompany();
    }, []);

    const [division, setDivision] = useState([]);

    const getdivision = async () => {
        setBuffering2(true);

        try {
            const result = await axios.get(`${BASE_URL}/dpr/division/`);
            setDivision(result.data)
        } catch (err) {

        } finally {
            setBuffering2(false);
        }
    }

    useEffect(() => {
        getdivision()
    }, [])


    const getSelectedTitle = () => {
        switch (toggleState) {
            case 1:
                return "Company Details";
            case 2:
                return "Sub Company Details";
            default:
                return "Company Details";
        }
    };
    return (


        <div>
            <div>

                <Dashboardnavbar name={getSelectedTitle()} url={"Company Management"} />
            </div>

            <div className="content-tabs ">
                <div className='toggle-button-area flex-row justify-between' style={{ padding: "15px 30px" }}>
                    <div className='flex-row justify-between' style={{ width: "100%" }}>
                        <div>
                            <button
                                className={
                                    toggleState === 1
                                        ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                        : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "
                                }
                                onClick={() => setToggleState(1)}
                            >
                                Company Details
                            </button>

                            <button
                                className={
                                    toggleState === 2
                                        ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs "
                                        : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "
                                }
                                onClick={() => setToggleState(2)}
                            >
                                Sub Company Details
                            </button>
                        </div>

                        {toggleState === 1 ?
                            <AddSubcompany getSubcompany={getSubcompany} /> :
                            <AddDivision getdivision={getdivision} />

                        }




                    </div>

                </div>

                <div >
                    {toggleState === 1 ? <SubCompany subComapany={subComapany} getSubcompany={getSubcompany} buffer={buffer} /> : null}
                    {toggleState === 2 ? <Division division={division} getdivision={getdivision} buffer={buffer2} /> : null}


                </div>
            </div>
        </div>
    );
};


export default MainDivision
